import { formNameToNice } from "django-rest-react";
import clsx from "clsx";
import React from "react";

export function FieldWrapper({
  name,
  label,
  helpText,
  error,
  errorClassName,
  children,
  wrapped,
}: {
  name: string,
  label?: string
  helpText?: string
  error?: string
  errorClassName?: string
  children: React.ReactNode
  wrapped: boolean
}) {
  const realLabel = !!label ? label : formNameToNice(name);
  const errorNode = error && (
    <div className={clsx("text-sm text-danger mt-1", errorClassName)}>{error}</div>
  );
  if (!wrapped) {
    return (
      <div>
        {children}
        {errorNode}
      </div>
    )
  } else {
    return (
      <div className="flex space-y-1 my-2">
        <label className="flex-1 block text-sm font-medium">{realLabel}</label>
        <div className="flex flex-col flex-4">
          {children}
          {helpText && <div className="text-xs mt-1 text-muted">{helpText}</div>}
          {errorNode}
        </div>
      </div>
    )
  }
}
